export default __webpack_public_path__ + "static/CINDIS-ad25e627b211e0b66ea3648eef50bec5.png";